import '../styles/main.scss';
import '@vitejs/plugin-react/preamble';
import Components from '../components';

if (Components.length) {
  Components.forEach((component) => component.init());
}
